import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogThree from "../../Blogdetails/BlogThree";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="Understanding the Role of a Pharmacist in Today's Healthcare System"
        />
        <BlogThree />
      </section>
    </>
  );
}

export default Main;
